import { isPreparingProjectMutation } from './project_mutation_scope.mjs';
import { invalidateRenderSceneContext } from '../render/render_scene_invalidation.mjs';

let projectModelRevision = 0;
let lastProjectModelChange = '';

function nextRevision(current) {
  return current >= Number.MAX_SAFE_INTEGER ? 1 : current + 1;
}

function markProjectModelChanged(reason = 'project-model-changed') {
  if (isPreparingProjectMutation()) return projectModelRevision;
  projectModelRevision = nextRevision(projectModelRevision);
  lastProjectModelChange = String(reason || 'project-model-changed');
  invalidateRenderSceneContext('model');
  return projectModelRevision;
}

function getProjectModelRevision() {
  return projectModelRevision;
}

function getProjectModelRevisionState() {
  return Object.freeze({
    revision: projectModelRevision,
    reason: lastProjectModelChange
  });
}

export {
  getProjectModelRevision,
  getProjectModelRevisionState,
  markProjectModelChanged
};
